import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const KEY = "nq_cookie_notice_ok";

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setShow(window.localStorage.getItem(KEY) !== "1");
  }, []);

  if (!show || pathname.startsWith("/admin")) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed bottom-24 left-4 right-24 z-[60] rounded-xl sm:bottom-4 sm:right-auto sm:max-w-sm border p-4 text-xs leading-relaxed shadow-2xl"
      style={{ background: "rgba(17,21,19,0.96)", borderColor: "rgba(198,162,74,0.35)", color: "#E9E2D2", backdropFilter: "blur(12px)" }}
      data-testid="cookie-notice"
    >
      <p>
        We use cookies to improve your experience. By continuing to use our website, you agree to our{" "}
        <Link to="/privacy-policy" className="font-semibold" style={{ color: "#C6A24A" }} data-testid="cookie-notice-privacy-link">
          Privacy Policy
        </Link>
        .
      </p>
      <button
        type="button"
        onClick={() => {
          window.localStorage.setItem(KEY, "1");
          setShow(false);
        }}
        className="btn-gold mt-3 px-5 py-1.5 text-xs"
        data-testid="cookie-notice-ok-button"
      >
        OK
      </button>
    </div>
  );
}
